export default __webpack_public_path__ + "static/media/18-460x460.57f904c7.jpeg";